<template>
	<div class="wai">
		<div style="
	  		color: #3e3e3e;
	  		font-size: 18px;margin-bottom: 15px;">用户管理>用户运营>用户运营-新建运营计划</div>
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">基本信息</div>
		</div>
		<!-- 第一部分 -->
		<div class="demo1">
			<div class="demo1_list1">
				<div>计划名称</div>
				<div>
					<el-input v-model="filter.planName" maxlength="30" size="small" style="width: 300px;" type="text"
						placeholder="人群名称,不超过30个字(不能含标点符号)"></el-input>
				</div>
			</div>
			<div class="demo1_list1">
				<div>目标人群</div>
				<div class="addpeople" @click="addperson=true">
					+选择人群
				</div>
			</div>
			<!-- 长期计划选项 -->
			<div class="demo1_list1">
				<div>计划方式</div>
				<div class="choose_person">
					<el-radio v-model="filter.planApproach" label="0">长期计划</el-radio>
					<div class="radio1">
						一个计划中的同一用户只会通知一次。人群中满足条件的新增客户，会自动收到营销通知
					</div>
				</div>
			</div>
			<div class="cheosepeo_1">
				<el-form v-if="filter.planApproach==0">
					<el-form-item label="执行日期">
						<el-date-picker value-format="yyyy-MM-dd" size="small" v-model="filter.time1" type="daterange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="通知时间">
						<div style="display: flex;">
							每天
							<el-time-select style="margin-left: 5px;margin-right: 5px;width: 150px;" size="small"
								v-model="filter.noticeTime" :picker-options="{
											    start: '00:00',
											    step: '00:15',
											    end: '24:00'
											  }" placeholder="选择时间">
							</el-time-select> 发送
						</div>
					</el-form-item>
				</el-form>
			</div>
			<!-- 长期计划选项结束 -->
			<!-- 长期计划选项 -->
			<div class="demo1_list1">
				<div></div>
				<div class="choose_person">
					<el-radio v-model="filter.planApproach" label="1">定时计划</el-radio>
					<div class="radio1">
						在指定时间向计划人群发送营销通知，可选择8:30-23:00的时间
					</div>
				</div>
			</div>
			<div class="cheosepeo_1" v-if="filter.planApproach==1">
				<el-form>
					<el-form-item label="通知时间">
						<div style="display: flex;">
							<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" size="small" v-model="filter.impTime"
								type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<!-- 长期计划选项结束 -->
		</div>
		<!-- 第一部分结束 -->
		<!-- 第三部分开始 -->
		<div class="title" style="margin-top: 20px;">
			<div class="blue"></div>
			<div style="flex: 1;">权益礼包</div>
		</div>
		<div class="demo2">
			<div class="demo2_list1">
				<div>优惠券</div>
				<div class="addpeople" @click="addjuan=true">
					+选择卷或卷包
				</div>
			</div>
		</div>
		<!-- 第三部分结束 -->
		<!-- 第三部分开始 -->
		<div class="title" style="margin-top: 20px;">
			<div class="blue"></div>
			<div style="margin-right:120px;">通知设置</div>
			<div class="noticelist" style="font-weight: 400;">
				<el-checkbox-group v-model="filter.noticeWays">
					<div class="check_wai">
						<div class="check_nei" v-for="(city,index) in cities" :key="index">
							<el-checkbox :label="city.values">{{city.value}}</el-checkbox>
							<div class="addpeople" style="margin-top: 10px;" @click="showdialog(city.values)">
								+{{city.name}}
							</div>
						</div>
					</div>
				</el-checkbox-group>
			</div>
		</div>
		<div class="button_s">
			<el-button size="small" @click="goback">取消</el-button>
			<el-button type="primary" @click="add" size="small">保存</el-button>
		</div>
		<!-- 第三部分结束 -->
		<!-- 发短信通知 -->
		<el-dialog :visible.sync="addjuan" width="50%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				添加卷/卷包
			</div>
			<div style="display: flex;">
				<el-input style="width:281px;" v-if="juanactiveName=='a'" v-model="juanname" size="small"
					placeholder="请输入优惠券名称" />
				<el-input style="width:281px;" v-if="juanactiveName=='b'" v-model="juanbname" size="small"
					placeholder="请输入卷包名称" />
				<el-button type="primary" size="small" style="margin-left: 10px;" @click="getjuan">搜索</el-button>
			</div>
			<div style="margin-top: 20px;">
				<el-tabs type="border-card" v-model="juanactiveName">
					<el-tab-pane name="a" label="卷">
						<el-table height="250" :data="juantable" style="width: 100%">
							<el-table-column label="选择">
								<template slot-scope="scope">
									<div>
										<el-checkbox style="width:18px;overflow: hidden;margin-left:8px;"
											v-model="filter.couponIds" :label="scope.row.id"></el-checkbox>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="title" label="名称">
							</el-table-column>
							<el-table-column prop="couponType" label="类型">
							</el-table-column>
							<el-table-column prop="storeListName" label="适用范围">
							</el-table-column>
							<el-table-column prop="content" label="卷内容">
							</el-table-column>
							<el-table-column prop="termOfValidity" label="有效期">
							</el-table-column>
							<el-table-column prop="getNumScaleTotalNum" label="已领取/卷总量">
							</el-table-column>
						</el-table>
						<div class="juanpages">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="juanfilter.page" :page-sizes="[5, 10, 15, 20]"
								:page-size="juanfilter.size" layout="total, sizes, prev, pager, next, jumper"
								:total="juanfilter.total">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane name="b" label="卷包">
						<el-table height="250" :data="juanbaotable" style="width: 100%">
							<el-table-column label="选择">
								<template slot-scope="scope">
									<div style="width: 50px;overflow: hidden;">
										<el-checkbox style="width:18px;overflow: hidden;margin-left:8px;"
											v-model="filter.couponPackageIds" :label="scope.row.id"></el-checkbox>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="名称">
							</el-table-column>
							<el-table-column prop="termOfValidity" label="有效期">
							</el-table-column>
							<el-table-column prop="getNumScaleTotalNum" label="已领取/卷总量">
							</el-table-column>
						</el-table>
						<div class="juanpages">
							<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
								:current-page="juanbfilter.page" :page-sizes="[5, 10, 15, 20]"
								:page-size="juanbfilter.size" layout="total, sizes, prev, pager, next, jumper"
								:total="juanbfilter.total">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addjuan = false">确 定</el-button>
			</span>
		</el-dialog>
		<!--短信通知 -->
		<el-dialog :visible.sync="short" width="38%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				短信通知
			</div>
			<el-form label-width="90px" label-position="left">
				<el-form-item label="收件对象">
					<div>
						<div>{{zhuan(filter.crowdIds)}}</div>
						<div style="font-size: 12px;color: #999999;margin-top: -20px;">发送时自动过滤没有手机号的用户</div>
					</div>
				</el-form-item>
				<el-form-item label="短信签名">
					<el-input size="small" v-model="filter.shortAutograph" placeholder="格式为[潮剪]"></el-input>
				</el-form-item>
				<el-form-item label="消息内容">
					<el-input type="textarea" v-model="filter.shortContent" rows="4" maxlength="300" show-word-limit
						placeholder="请输入短信内容"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="short = false">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 发微信服务号通知 -->
		<el-dialog :visible.sync="servicenotice" width="38%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				微信服务号通知
			</div>
			<el-form label-width="90px" label-position="left">
				<el-form-item label="收件对象">
					<div>
						<div>{{zhuan(filter.crowdIds)}}</div>
						<div style="font-size: 12px;color: #999999;margin-top: -20px;">发送时自动过滤没有手机号的用户</div>
					</div>
				</el-form-item>
				<el-form-item label="通知内容">
					<el-input size="small" v-model="filter.wecServiceContent" placeholder="请输入通知内容"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="servicenotice = false">保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="appletmessage" width="38%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				小程序消息
			</div>
			<el-form label-width="90px" label-position="left">
				<el-form-item label="收件对象">
					<div>
						<div>{{zhuan(filter.crowdIds)}}</div>
						<div style="font-size: 12px;color: #999999;margin-top: -20px;">发送时自动过滤没有手机号的用户</div>
					</div>
				</el-form-item>
				<el-form-item label="发送人昵称">
					<el-input size="small" v-model="filter.smallRoutineSendNickname" placeholder="请输入发送人昵称"></el-input>
				</el-form-item>
				<el-form-item label="消息内容">
					<el-input type="textarea" v-model="filter.smallRoutineContent" maxlength="300" show-word-limit
						rows="4" placeholder="请输入短信内容"></el-input>
				</el-form-item>
				<el-form-item label="链接名称">
					<el-input size="small" v-model="filter.smallRoutineLinkTitle" maxlength="20" show-word-limit
						placeholder="如:戳我领红包"></el-input>
				</el-form-item>
				<div style="display: flex;">
					<div style="margin-right: 30px;">
						<el-select style="width: 120px;" v-model="filter.linkType" size="small">
							<el-option value="外部链接">外部链接</el-option>
							<el-option value="无跳转">无跳转</el-option>
							<el-option value="小程序链接">小程序链接</el-option>
							<el-option value="会员页">会员页</el-option>
						</el-select>
					</div>
					<el-input size="small" v-model="filter.smallRoutineLink" placeholder="请输入链接名称"></el-input>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="appletmessage = false">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 小程序通知 -->
		<!-- 发微信服务号通知 -->
		<el-dialog :visible.sync="addperson" width="37%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				添加人群
			</div>
			<div class="personlist">
				<div class="personlist1">
					<el-checkbox-group v-model="filter.crowdIds">
						<div v-for="i in labellist" style="margin-top: 10px;">
							<el-checkbox class="checkeds" :label="i.value" :key="i.value">{{i.label}}</el-checkbox>
						</div>
					</el-checkbox-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addperson = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	var that
	const isEmpty = (str) => {
		if (str === '' || str === undefined || str === null) {
			return true
		}
		return false
	}
	export default {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			row: {
				type: Number,
				default: 3
			},
			maxLength: {
				type: Number,
				default: 300
			}
		},
		data() {
			return {
				filter: {
					crowdIds: [], //人群id
					couponIds: [], //优惠券选中
					couponPackageIds: [], //优惠券包选中
					planName: "", //计划名称
					planApproach: "0", //计划方式
					impTime: "", //长期计划通知时间
					time1: "", //长期计划
					noticeTime: "", //定时计划
					noticeWays: [], //通知方式
					// 短信
					shortAutograph: "", //短信签名
					shortContent: "", //短信内容
					// 微信服务号
					wecServiceContent: "", // 微信服务号内容
					// 小程序
					smallRoutineSendNickname: "", //发送人昵称
					smallRoutineContent: "", //小程序内容
					linkType: "外部链接", //链接类型
					smallRoutineLinkTitle: "", //链接名称
					smallRoutineLink: "", //发送小程序信息链接名称
				},
				// 判断添加人群是否打开
				addperson: false,
				//判断添加卷是否打开
				addjuan: false,
				labellist: [], //标签列表
				juanname: "", //筛选优惠券名称
				juantable: [], //卷列表
				juanfilter: {
					page: 1,
					size: 5,
					total: 0
				},
				juanactiveName: "a", //判断当前选择是卷或卷包
				juanbname: "", //筛选优惠券名称
				juanbfilter: {
					page: 1,
					size: 5,
					total: 0
				},
				juanbaotable: [], //卷包列表
				short: false, //判断是否打开短信
				appletmessage: false, //判断小程序消息弹窗是否打开
				servicenotice: false, //微信服务号通知
				mylist: [],
				cities: [{
					value: "发短信通知",
					name: "添加短信内容",
					values: 1
				}, {
					value: "发微信服务号通知",
					name: "添加消息内容",
					values: 2
				}, {
					value: "发微信小程序通知",
					name: "添加消息内容",
					values: 3
				}, ]
			}
		},
		computed: {
			zhuan: () => {
				return (value) => {
					if (value.length > 0) {
						var a = ""
						if (that.labellist.length > 0) {
							for (let i in value) {
								if (value.length > 1) {
									a += "   " + that.labellist[i].label
								} else {
									a += that.labellist[i].label
								}
							}
							return a
						}
					}
					return "未选中"
				}
			},
			// 计算当前文本框中内容的字数
			valueLength() {
				if (isEmpty(this.textAreaVal)) {
					return 0
				}
				return this.textAreaVal.length
			}
		},
		watch: {
			// 监听value的变化
			value: {
				handler(val, oldVal) {
					this.textAreaVal = val
				},
				immediate: true
			}
		},
		created() {
			this.getlist()
		},
		mounted() {
			that = this
			//获取标签列表
			this.getlabel()
			//获取优惠券列表
			this.getjuan()
		},
		methods: {
			getlist() {
				if (this.$route.query.id) {
					this.$http.get("dUserOperate/getOperateById?id=" + this.$route.query.id).then(function(res) {
						console.log(res)
						if (res.body.code == 200) {
							var arr = res.body.data
							// 赋值人群id
							var coupon = arr.crowdId.split(", ").map(e => e = Number(e));
							// 赋值时间
							if (arr.impDateTop) {
								var time1 = []
								time1[0] = arr.impDateTop
								time1[1] = arr.impDateTail
							}
							var couponId = arr.couponId.split(", ").map(e => e = Number(e));
							var couponPackageId = arr.couponPackageId.split(", ").map(e => e = Number(e));
							let couponIds = []
							// arr.couponIds=arr.couponId.splice(",")
							// for(let i in arr.couponIds){
							// 	couponIds.push(arr.couponIds[i])
							// }
							let couponPackageIds = []
							// arr.couponPackageIds=arr.couponPackageId.splice(",")
							// for(let i in arr.couponPackageIds){
							// 	couponPackageIds.push(arr.couponPackageIds[i])
							// }
							let noticeWays = []
							arr.noticeWays = arr.noticeWay.split(",")
							for (let i in arr.noticeWays) {
								noticeWays.push(Number(arr.noticeWays[i]))
							}
							// console.log(noticeWays)
							this.filter = {
								crowdIds: coupon, //人群id
								couponIds: couponId, //优惠券选中
								couponPackageIds: couponPackageId, //优惠券包选中
								planName: arr.planName, //计划名称
								planApproach: arr.planApproach.toString(), //计划方式
								impTime: arr.impTime, //长期计划通知时间
								time1: time1, //长期计划
								noticeTime: arr.noticeTime, //定时计划
								noticeWays: noticeWays, //通知方式
								// 短信
								shortAutograph: arr.shortAutograph, //短信签名
								shortContent: arr.shortContent, //短信内容
								// 微信服务号
								wecServiceContent: arr.wecServiceContent, // 微信服务号内容
								// 小程序
								smallRoutineSendNickname: arr.smallRoutineSendNickname, //发送人昵称
								smallRoutineContent: arr.smallRoutineContent, //小程序内容
								linkType: "外部链接", //链接类型
								smallRoutineLinkTitle: arr.smallRoutineLinkTitle, //链接名称
								smallRoutineLink: arr.smallRoutineLink //发送小程序信息链接名称
							}
						}
					}, function(err) {
						this.$message.error("请求失败")
					})
				}
			},
			// 添加计划
			add() {
				let arr = {}
				if (this.$route.query.id) {
					arr.id = this.$route.query.id
				}
				console.log(this.filter.time1)
				if (this.filter.planName == "") {
					this.$message.error("计划名称不能为空")
					return false
				}
				arr.planName = this.filter.planName
				if (this.filter.crowdIds.length == 0) {
					this.$message.error("请选择人群")
					return false
				}
				arr.crowdIds = this.filter.crowdIds
				if (this.filter.planApproach == 0) {

					if (!this.filter.time1) {
						this.$message.error("请选择执行时间")
						return false
					}
					if (!this.filter.noticeTime) {
						this.$message.error("请选择长期计划通知时间")
						return false
					}
					arr.impDateTop = this.filter.time1[0]
					arr.impDateTail = this.filter.time1[1]
					arr.noticeTime = this.filter.noticeTime
				} else {
					if (!this.filter.impTime) {
						this.$message.error("请选择定时计划通知时间")
						return false
					}
					arr.impTime = this.filter.impTime
				}
				arr.planApproach = this.filter.planApproach
				if (this.filter.couponIds.length == 0 && this.filter.couponPackageIds.length == 0) {
					this.$message.error("请选择优惠券")
					return false
				}
				arr.couponIds = this.filter.couponIds
				arr.couponPackageIds = this.filter.couponPackageIds
				if (this.filter.noticeWays.indexOf(1) != -1) {
					if (!this.filter.shortAutograph) {
						this.$message.error("短信通知签名不能为空")
						return false
					}
					if (!this.filter.shortContent) {
						this.$message.error("短信通知内容不能为空")
						return false
					}
					arr.shortAutograph = this.filter.shortAutograph
					arr.shortContent = this.filter.shortContent
				}
				if (this.filter.noticeWays.indexOf(2) != -1) {
					if (!this.filter.wecServiceContent) {
						this.$message.error("微信服务号通知内容不能为空")
						return false
					}
					arr.wecServiceContent = this.filter.wecServiceContent
				}
				if (this.filter.noticeWays.indexOf(3) != -1) {
					if (!this.filter.smallRoutineLink) {
						this.$message.error("小程序消息发送人昵称不能为空")
						return false
					}
					if (!this.filter.smallRoutineLinkTitle) {
						this.$message.error("小程序消息内容不能为空")
						return false
					}
					arr.linkType = this.filter.linkType
					arr.smallRoutineLinkTitle = this.filter.smallRoutineLinkTitle
					arr.smallRoutineLink = this.filter.smallRoutineLink
				}
				if (this.filter.noticeWays.length == 0) {
					this.$message.error("请选择通知方式")
					return false
				}
				arr.noticeWays = this.filter.noticeWays
				console.log(arr)
				this.$http.post("dUserOperate/saveOrUpdate", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						if (this.$route.query.id) {
							this.$message.success("修改成功")
							this.$router.go(-1)
						} else {
							this.$message.success("添加成功")
							this.$router.go(-1)
						}
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 获取标签列表
			getlabel() {
				this.$http.get("dUserLabel/list", {
					params: {
						page: 1,
						size: 999999
					}
				}, {
					emulateJSON: true
				}).then(function(res) {
					this.labellist = []
					if (res.body.code == 200) {
						for (let i in res.body.data) {
							var a = {
								label: res.body.data[i].labelName,
								value: res.body.data[i].id
							}
							this.labellist.push(a)
						}
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 获取优惠券和卷包列表
			getjuan() {
				this.$http.get("dUserOperate/coupon", {
					params: {
						page: this.juanfilter.page,
						size: this.juanfilter.size,
						name: this.juanname
					}
				}, {
					emulateJSON: true
				}).then(function(res) {
					if (res.body.code == 200) {
						this.juantable = res.body.data
						this.juanfilter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
				let arr = {
					pageNum: this.juanbfilter.page,
					pageSize: this.juanbfilter.size,
					name: this.juanbname
				}
				this.$http.get("dUserOperate/couponPackage", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.juanbaotable = res.body.data
						this.juanbfilter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			goback() {
				this.$router.go(-1)
			},
			handleSizeChange(val) {
				this.juanfilter.size = val
				this.getjuan()
			},
			handleCurrentChange(val) {
				this.juanfilter.page = val
				this.getjuan()
			},
			handleSizeChange2(val) {
				this.juanbfilter.size = val
				this.getjuan()
			},
			handleCurrentChange2(val) {
				this.juanbfilter.page = val
				this.getjuan()
			},
			// 计算textAreaVal值，超过最大值则直接截断
			handleInputChange() {
				this.textAreaVal = this.textAreaVal.substring(0, this.maxLength)
				this.$emit('change', this.textAreaVal)
			},
			claer() {
				this.$confirm('是否要删除该标签?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			showdialog(val) {
				if (val == 1) {
					this.short = true
				}
				if (val == 2) {
					this.servicenotice = true
				}
				if (val == 3) {
					this.appletmessage = true
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 43%;
	}

	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.check_wai {
		display: flex;

		.check_nei {
			margin-left: 50px;
			flex: 1;
		}
	}

	.addpeople {
		cursor: pointer;
		border: 1px dashed #9E9E9E;
		height: 28px;
		line-height: 28px;
		padding-left: 20px;
		padding-right: 20px;
		font-size: 14px;
		color: #9E9E9E;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第一部分
	.demo1 {
		width: 100%;

		.cheosepeo_1 {
			margin-top: 20px;
			margin-left: 200px;
		}

		.demo1_list1 {
			margin-top: 20px;
			display: flex;

			>div {
				&:nth-child(1) {
					width: 200px;
				}
			}

			.addpeople {
				cursor: pointer;
				border: 1px dashed #9E9E9E;
				height: 28px;
				line-height: 28px;
				padding-left: 20px;
				padding-right: 20px;
				font-size: 14px;
				color: #9E9E9E;
			}

			.choose_person {
				display: flex;

				.radio1 {
					transform: translate(0, -3 px);
					width: 700px;
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #3F3F3F;
					opacity: 0.35;
				}
			}
		}
	}

	// 第二部分
	.demo2 {
		.demo2_list1 {
			margin-top: 20px;
			display: flex;

			div {
				&:nth-child(1) {
					width: 200px;
				}
			}

			.addpeople {
				cursor: pointer;
				border: 1px dashed #9E9E9E;
				height: 28px;
				line-height: 28px;
				padding-left: 20px;
				padding-right: 20px;
				font-size: 14px;
				color: #9E9E9E;
			}
		}
	}

	.button_s {
		width: 200px;
		margin-left: 30%;
		margin-top: 20px;
	}

	.diap1 {
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
	}

	.diap2 {
		margin-top: -15px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #BCBCBC;
	}

	//文本域
	/deep/ .text-area {
		width: 380px;
		padding-bottom: 24px;
		border: 1px solid;
		border-color: #dcdfe6;
		border-radius: 4px;

		.el-textarea__inner {
			border: none;
		}
	}

	.remain-word {
		position: absolute;
		right: 60px;
		bottom: -8px;
	}

	.remain-word2 {
		position: absolute;
		right: 60px;
		top: 2px;
	}

	.juanpages {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>